module.exports = __webpack_public_path__ + "/images/cover-acompanamos-embarazo.1998fd5.png";